import { LABELS } from "~/resources/Labels";
import { TemplateResponse } from "~/models/Commons ";
import { SIMPLDialog } from "../.././components/commons/dialog/SimplDialog";
import { useTranslation } from "react-i18next";

interface DetailProps {
  item?: TemplateResponse;
  onClose: () => void;
  title: string;
}

const labelClass = "font-semibold max-w-[300px]";
export const DetailsVmTemplate = ({ title, item, onClose }: DetailProps) => {
  const { t } = useTranslation();
  return (
    <SIMPLDialog onCloseModal={onClose} title={t(`${title}`)}>
      <div className="w-auto p-2 pb-5 flex flex-col">
        <div className="flex flex-row mt-3">
          <div className="flex-1">
            <div className={labelClass}>{t("Name")}</div>
            <div className={""}>{item?.name}</div>
          </div>
        </div>
        <div className="flex flex-row mt-3">
          <div className="flex-1">
            <div className={labelClass}>{t("Description")}</div>
            <div className={""}>{item?.description}</div>
          </div>
        </div>
        <div className="flex-1">
          <div className={labelClass}>{t("CloudEnvironment")}</div>
          <div className={""}>
            {item?.cloudEnvironment.environmentName}
          </div>
        </div>
        <div className="flex-1">
          <div className={labelClass}>{t("Provider")}</div>
          <div className={""}>
            {item?.cloudEnvironment.cloudProvider.cloudProviderName}
          </div>
        </div>
        <div className="flex flex-row mt-3">
          <div className="flex-1">
            <div className={labelClass}>{t("ProvisionerTemplate")}</div>
            <div className={""}>
              {item?.cloudProvisionerTemplate.fileName}
            </div>
          </div>
        </div>
        {item?.cloudProvisionerTemplate.ovhFlavor && (
          <div className="flex flex-row mt-3">
            <div className="flex-1 truncate">
              <div className={labelClass}>{t("OvhFlavor")}</div>
              <div className={""}>
                {item?.cloudProvisionerTemplate.ovhFlavor}
              </div>
            </div>
          </div>
        )}
        {item?.cloudProvisionerTemplate.ovhProjectId && (
          <div className="flex flex-row mt-3">
            <div className="flex-1 truncate">
              <div className={labelClass}>{t("OvhProjectId")}</div>
              <div className={""}>
                {item?.cloudProvisionerTemplate.ovhProjectId}
              </div>
            </div>
          </div>
        )}
        {item?.cloudProvisionerTemplate.ovhRegion && (
          <div className="flex flex-row mt-3">
            <div className="flex-1 truncate">
              <div className={labelClass}>{t("OvhRegion")}</div>
              <div className={""}>
                {item?.cloudProvisionerTemplate.ovhRegion}
              </div>
            </div>
          </div>
        )}
        {item?.os && (
          <div className="flex flex-row mt-3">
            <div className="flex-1">
              <div className={labelClass}>{t("Os")}</div>
              <div className={""}>{item?.os}</div>
            </div>
          </div>
        )}

        {item?.cpuCore && (
          <div className="flex flex-row mt-3">
            <div className="flex-1 truncate">
              <div className={labelClass}>{t("CpuCore")}</div>
              <div className={""}>{item?.cpuCore}</div>
            </div>
          </div>
        )}
        {item?.storage && (
          <div className="flex flex-row mt-3">
            <div className="flex-1 truncate">
              <div className={labelClass}>{t("Storage")}</div>
              <div className={""}>{item?.storage}</div>
            </div>
          </div>
        )}
        {item?.ram && (
          <div className="flex flex-row mt-3">
            <div className="flex-1 truncate">
              <div className={labelClass}>{t("Ram")}</div>
              <div className={""}>{item?.ram}</div>
            </div>
          </div>
        )}
      </div>
    </SIMPLDialog>
  );
};
